import { useState } from 'react';
import { Link } from 'react-router-dom';
import { comicList } from '@/mocks/comics';

type RankType = 'popular' | 'newest' | 'finished';

const rankTabs: { key: RankType; label: string }[] = [
  { key: 'popular', label: '人气榜' },
  { key: 'newest', label: '新作榜' },
  { key: 'finished', label: '完结榜' },
];

export default function RankingList() {
  const [activeTab, setActiveTab] = useState<RankType>('popular');

  const getRankedList = () => {
    switch (activeTab) {
      case 'popular':
        return [...comicList].sort((a, b) => b.views - a.views).slice(0, 10);
      case 'newest':
        return [...comicList].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 10);
      case 'finished':
        return comicList.filter((c) => c.status === '已完结').slice(0, 10);
      default:
        return comicList.slice(0, 10);
    }
  };

  const rankedList = getRankedList();

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">排行榜</h2>
      </div>
      <div className="flex items-center gap-1 mb-6 bg-background-100 rounded-full p-1 w-fit">
        {rankTabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              activeTab === tab.key
                ? 'bg-primary-500 text-white shadow-sm'
                : 'text-foreground-600 hover:text-foreground-900'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
        {rankedList.map((comic, index) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.id}`}
            className="group flex items-center gap-3 p-3 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
          >
            <div className={`w-7 h-7 flex items-center justify-center rounded-full font-bold text-xs flex-shrink-0 ${
              index < 3 ? 'bg-primary-500 text-white' : 'bg-background-200 text-foreground-600'
            }`}>
              {index + 1}
            </div>
            <div className="w-12 h-16 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
              <img
                src={comic.coverImage}
                alt={comic.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">{comic.title}</p>
              <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-accent-500 flex items-center gap-0.5">
                  <i className="ri-star-fill text-[10px]"></i>
                  {comic.rating}
                </span>
                <span className="text-xs text-foreground-400">
                  {(comic.views / 10000).toFixed(0)}万阅
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}